import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { GuestsLimits } from 'entities/kyrgyzstan/config/guests'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ButtonIconTextWithLabel } from 'shared/ui/button-icon-text-with-label'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

export interface StaySummaryParams {
  start_date?: string
  end_date?: string
  visitors_count?: number
  children_ages?: number[]
}

interface StaySummarySectionProps {
  stayParams?: StaySummaryParams | null
  onOpenDates?: () => void
  onOpenGuests?: () => void
}

export const StaySummarySection: FC<StaySummarySectionProps> = ({
  stayParams,
  onOpenDates,
  onOpenGuests,
}) => {
  const { t } = useTranslation()
  const adultsCount = stayParams?.visitors_count ?? GuestsLimits.adults.default
  const childrenCount = stayParams?.children_ages?.length ?? 0
  const guestsText = [
    t('kyrgyzstan_block.search_form.adult', { count: adultsCount }),
    childrenCount
      ? t('kyrgyzstan_block.search_form.child', { count: childrenCount })
      : null,
  ]
    .filter(Boolean)
    .join(', ')
  const checkinDate = stayParams?.start_date
    ? dateFormat(stayParams.start_date, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR)
    : ''
  const checkoutDate = stayParams?.end_date
    ? dateFormat(stayParams.end_date, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR)
    : ''

  return (
    <>
      <Paper
        padding={[12, 14]}
        radius="16"
      >
        <div className={s.content}>
          <p className={clsx('bold-14', s.title)}>
            {t('kyrgyzstan_block.calendar.title')}
          </p>

          <div className={s.dates}>
            <ButtonIconTextWithLabel
              type="grey"
              height="auto"
              value={checkinDate}
              placeholder={t('kyrgyzstan_block.calendar.checkin')}
              disabled={!onOpenDates}
              onClick={onOpenDates}
            />

            <ButtonIconTextWithLabel
              type="grey"
              height="auto"
              value={checkoutDate}
              placeholder={t('kyrgyzstan_block.calendar.checkout')}
              disabled={!onOpenDates}
              onClick={onOpenDates}
            />
          </div>
        </div>
      </Paper>

      <Paper
        padding={[12, 14]}
        radius="16"
      >
        <div className={s.content}>
          <p className={clsx('bold-14', s.title)}>
            {t('kyrgyzstan_block.search_form.guests')}
          </p>

          <ButtonIconTextWithLabel
            type="grey"
            height="auto"
            value={guestsText}
            placeholder={t('kyrgyzstan_block.search_form.guests')}
            rightIcon={AllIcons.PEOPLE_NEW_INPUT}
            disabled={!onOpenGuests}
            onClick={onOpenGuests}
          />
        </div>
      </Paper>
    </>
  )
}
